const GetUsersServices = async (props) => {
    try {
        const response = await fetch(`https://erpleiten.dnscheck.com.ar/ws/GetUsuarioById?idusuario=${props}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return (data);
    } catch (error) {
        console.error('Error fetching currency:', error);
        return null;
    }
}

export default GetUsersServices